import React from "react";
import { CheckBox } from "devextreme-react";

const SignOnPages = ({ value, onValueChange }) => {
  const { use_login_app, enable_security_emails } = value;
  return (
    <div className="mb-5">
      <table className="table table-bordered align-middle mt-1">
        <thead className="table-dark">
          <tr>
            <th scope="col">Setting</th>
            <th scope="col">Value</th>
            <th scope="col">Explanation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Allow Only login.erply.com</th>
            <td className="text-center" style={{ width: "40%" }}>
              {" "}
              <CheckBox
                value={use_login_app}
                onValueChanged={(e) => onValueChange(e, "use_login_app")}
              />
            </td>
            <td style={{ width: "30%" }}>
              Turn this setting on to make{" "}
              <a
                href="https://login.erply.com"
                target="_blank"
                rel="noreferrer"
              >
                login.erply.com
              </a>{" "}
              the only allowed sign-on page. This is to ensure that users cannot
              bypass Single Sign-On, two-factor authentication or password
              rotation requirements by using old back office and POS log-in
              forms. <br /> <br /> To turn this setting on, you need to use
              Brazil POS. Older POS applications do not support login.erply.com.
            </td>
          </tr>
          <tr>
            <th scope="row">Notify Users About New Log-In Locations</th>
            <td className="text-center" style={{ width: "40%" }}>
              {" "}
              <CheckBox
                value={enable_security_emails}
                onValueChanged={(e) =>
                  onValueChange(e, "enable_security_emails")
                }
              />
            </td>
            <td style={{ width: "30%" }}>
              If enabled, Erply will send a notification email to the user when
              they log in from a location that they have not used previously.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SignOnPages;
